const dayEn = {
    day: require('../../lang/en/day/Day').default,
};
export default dayEn;
